import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';

const LuwaCheckinVerification = (props) => {
  const config = useConfig();
  const [isProgressVisible] = useState(true);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const match = useParams();
  const params = parseUrlParams(window.location.search);
  const { fetch, navigate, checkinData } = props;

  useEffect(() => {
    const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
    props.newCheckInAction({
      key: params.key,
      workflowType,
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    });
  }, []);

  useEffect(() => {
    if (fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`] && !get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))) {
      // extract route url from the api response
      let routeUrl = get(checkinData, 'data.url', '').replace(config.hostUrl, '');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [checkinData, fetch]);

  return (
    <Transition className="transition-item wrapper v-center">
      <Header navigate={navigate} />
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

LuwaCheckinVerification.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LuwaCheckinVerification);
